import { render, staticRenderFns } from "./SamPagination.vue?vue&type=template&id=2fd24a88&scoped=true&"
import script from "./SamPagination.vue?vue&type=script&lang=js&"
export * from "./SamPagination.vue?vue&type=script&lang=js&"
import style0 from "./SamPagination.vue?vue&type=style&index=0&id=2fd24a88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd24a88",
  null
  
)

export default component.exports